module.exports = __webpack_public_path__ + "static/media/dropup-blue.345dad74.svg";